import api from "@/services/api";

export default {
  getList(params) {
    return api.get("/report/opname-license", { params });
  },
  exportExcel(params) {
    return api.get("/report/opname-license/export-excel", {
      params,
      responseType: "blob",
    });
  },
};
